export default __webpack_public_path__ + "static/media/Astrid.44c487a5.svg";